import React from 'react'

export const PopoverItem = ({text,icon,...props}) => {
    return (
        <div className='popover_item gap-3' {...props}>
            <div>
                {icon}
            </div>
            <div>
                {text}
            </div>
        </div>
    )
}
